import { useState } from "react";
import { Collapse } from "@mui/material";
import companyCheckboxIcon from "../../assets/yfs_label/product_yfs_label/icons/company-checkbox.svg";
import supplierCheckboxIcon from "../../assets/yfs_label/product_yfs_label/icons/supplier-checkbox.svg";
import initialCheckboxIcon from "../../assets/yfs_label/product_yfs_label/icons/initial-grey-checkbox.svg";
import internalCheckboxIcon from "../../assets/yfs_label/product_yfs_label/icons/internal-checkbox.svg";
import publicCheckboxIcon from "../../assets/yfs_label/product_yfs_label/icons/public-checkbox.svg";
import "./index.css";
const CustomStatusCheckbox = ({
  checked,
  onChange,
  itemKey,
  categories,
  handleCategoryChange,
}) => {
  const [expanded, setExpanded] = useState(false);
  const [isPublic, setIsPublic] = useState(false);

  const getCategoryValue = () => {
    // Handle certificates
    if (itemKey.startsWith("certificates_")) {
      const certName = itemKey.replace("certificates_", "");
      return categories.certificates?.[certName];
    }

    // Handle variation categories
    if (itemKey.startsWith("variation_categories_")) {
      const path = itemKey.replace("variation_categories_", "");
      return categories.variation_categories?.[path];
    }

    // Fallback to direct access for other cases
    return categories[itemKey];
  };

  const handlePublicClick = () => {
    setIsPublic(!isPublic);
    onChange();
    setExpanded(false);
  };

  const handleStatusButtonClick = () => {
    const selectedCategory = getCategoryValue();

    if (isPublic || selectedCategory) {
      setIsPublic(false);
      handleCategoryChange(itemKey, "");
      onChange();
      setExpanded(false);
    } else {
      setExpanded(!expanded);
    }
  };

  const getIcon = (category, isPublic) => {
    if (category) {
      switch (category) {
        case "Third party verified":
          return companyCheckboxIcon;
        case "Supplier information":
          return supplierCheckboxIcon;
        case "Company information":
          return internalCheckboxIcon;
        default:
          return initialCheckboxIcon;
      }
    }

    if (isPublic) {
      return publicCheckboxIcon;
    }

    return initialCheckboxIcon;
  };

  const selectedCategory = getCategoryValue();

  return (
    <div className="status-checkbox-container">
      <button onClick={handleStatusButtonClick} className="status-button">
        <img
          src={getIcon(selectedCategory, isPublic)}
          alt="Status Checkbox"
          width={25}
          height={25}
        />
      </button>

      <Collapse in={expanded}>
        <div className="dropdown-menu">
          <button
            onClick={handlePublicClick}
            className="status-button public-btn"
          >
            <img
              src={publicCheckboxIcon}
              alt="Public Checkbox"
              width={25}
              height={25}
            />
          </button>

          <button
            onClick={() => {
              setIsPublic(!isPublic);
              onChange();
              handleCategoryChange(itemKey, "Third party verified");
              setExpanded(false);
            }}
            className="status-button verified-btn"
            style={{ marginTop: "-10px" }}
          >
            <div className="checkbox-inner">
              <img
                src={companyCheckboxIcon}
                alt="Company Checkbox"
                width={25}
                height={25}
              />
            </div>
          </button>

          <button
            onClick={() => {
              setIsPublic(!isPublic);
              onChange();
              handleCategoryChange(itemKey, "Supplier information");
              setExpanded(false);
            }}
            className="status-button supplier-btn"
            style={{ marginTop: "-10px" }}
          >
            <div className="checkbox-inner">
              <img
                src={supplierCheckboxIcon}
                alt="Supplier Checkbox"
                width={25}
                height={25}
              />
            </div>
          </button>

          <button
            onClick={() => {
              setIsPublic(!isPublic);
              onChange();
              handleCategoryChange(itemKey, "Company information");
              setExpanded(false);
            }}
            className="status-button internal-btn"
            style={{ marginTop: "-10px" }}
          >
            <div className="checkbox-inner">
              <img
                src={internalCheckboxIcon}
                alt="Internal Checkbox"
                width={25}
                height={25}
              />
            </div>
          </button>
        </div>
      </Collapse>
    </div>
  );
};

export default CustomStatusCheckbox;
